import Morda from './Morda';

export default Morda;